module.exports = __webpack_public_path__ + "img/left.4786d7e5.svg";